import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class GMailService {

  url = "/api/google";

  constructor(private http: HttpClient, private loaderService:LoaderService) { }

  authorize(): Observable<object> {
    return this.http.get<object>(this.url + "/google/authorize");
  }

  me(): Observable<object> {
    this.loaderService.skipRequest(this.url + "/google/me", null);
    return this.http.get<object>(this.url + "/google/me");
  }

  users(id): Observable<object> {
    return this.http.get<object>(this.url + "/google/" + id + "/users");
  }

}
